<div class="faq-page">
  <vw-page
    [alwaysFillNav]="true"
    *ngIf="page"
    [page]="page"
    [showDealerInformation]="true"
  >
    <vw-page-header>
      <div breadcrumbs>
        <vw-breadcrumbs [currentPage]="'faq' | translate"></vw-breadcrumbs>
      </div>
    </vw-page-header>

    <div class="container">
      <div class="row header-row align-items-center">
        <div class="col-12 col-lg-4 offset-lg-1">
          <img class="img-fluid" src="./assets/img/faq.jpg" alt="FAQ" />
        </div>
        <div class="col-12 col-lg-7">
          <h1>{{ "faqPage.title" | translate }}</h1>
          <p>{{ "faqPage.subTitle" | translate }}</p>
        </div>
      </div>
    </div>

    <div *ngIf="faqSections && !!faqSections.length" class="container mt-5">
      <!-- <div class="row">
        <div class="col-12 col-lg-8 mx-auto">
          <vw-text-box
            class="search-text-box"
            [placeholder]="'faqPage.search' | translate"
            [id]="'faqSearch'"
            [parentForm]="searchForm"
            [formControlProp]="'search'"
          ></vw-text-box>
        </div>
      </div> -->

      <div *ngFor="let section of faqSections | faqSearch: ''" class="mb-5">
        <div class="row justify-content-center">
          <h2>
            {{ "faqPage.sectionTitles." + section.sectionTypeName | translate }}
          </h2>
        </div>
        <div
          *ngFor="let item of section.components ?? [] | faqSearch: ''"
          class="row justify-content-center"
        >
          <vw-toggleable
            [defaultToggled]="false"
            [entireHeaderClickable]="true"
            class="col-lg-8 mx-auto"
          >
            <div header>
              <h4 class="m-0 pe-2">
                {{
                  item.media
                    | media: mediaCategoryTypeNames.Title : mediaTypes.Text
                }}
              </h4>
            </div>
            <div class="toggled-content">
              <span
                [innerHTML]="
                  item.media
                    | media: mediaCategoryTypeNames.Body : mediaTypes.HTML
                    | safe: 'html'
                "
              ></span>
            </div>
          </vw-toggleable>
        </div>
      </div>
    </div>
  </vw-page>
</div>
